import React from 'react';

const DashboardUpgradePlan = () => {
  return <div>Upgrade plan page</div>;
};

export default DashboardUpgradePlan;
